import { FlatBadge } from "../Badges/FlatBadge"

export const HorizontalLinkCard = ({action, name, badge}) => {
  return (
    <div
      className="relative flex items-center space-x-3 rounded-lg border border-gray-500 bg-white px-3 py-1 shadow-md cursor-pointer hover:border-gray-400"
      onClick={action}
    >
      <div className="min-w-0 flex-1">
        <div className="inline-block focus:outline-none">
          <span className="absolute inset-0" aria-hidden="true" />
          <p className="text-md font-bold text-gray-600">{name}</p>
        </div>
      </div>
      {badge && <FlatBadge text={badge.text} color={badge.color} />}
    </div>
  )
}